import React, { useCallback, useState } from 'react';

import Home from './Home';

function HomeContainer() {
  const [isEditing, setEditing] = useState(false);
  const onEditToggle = useCallback(() => setEditing((v) => !v), []);
  return <Home isEditing={isEditing} onEditToggle={onEditToggle} />;
}

export default HomeContainer;
